import useApplication from '@platform-ui-common/hooks/contexts/useApplication.js';
import useApplicationConfig from '@platform-ui/application/hooks/useApplicationConfig.js';
import ApplicantRoutes from '@platform-ui/application/utils/ApplicantRoutes.js';
import { makeRoute } from '@platform-ui/utilities/Routes.js';
import { getApplicantSections } from '@platform-ui/utilities/application/config.js';
import { getSectionRoute } from '@platform-ui/utilities/application/section.js';
import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useSearchParams } from 'react-router-dom-v5-compat';

type PushApplicationPage = (route: string) => void;

export default function usePushApplicationPage(): PushApplicationPage {
  const fromReview = useSearchParams()[0].get('review') === 'true';
  const history = useHistory();
  const config = useApplicationConfig();
  const sections = getApplicantSections(config);
  const application = useApplication();

  return useCallback(
    (toRoute: string) => {
      const isLastScreen = sections.some(
        (section) => getSectionRoute(section, application.answers) === toRoute,
      );

      let route: string;
      if (fromReview && isLastScreen) route = ApplicantRoutes.APPLICATION_REVIEW;
      else route = `${toRoute}${fromReview ? `?review=${fromReview}` : ''}`;

      history.push(makeRoute(route, { applicationId: application.id }));
    },
    [history, application, fromReview, sections],
  );
}
